import {Modal} from 'react-bootstrap'
import {
  deleteDiscount,
  cancelDeleteDiscount
} from 'actions/library/discount'
import styles from './ConfirmDeleteModal.css'
import {connect} from 'react-redux'

class ConfirmDeleteModal extends React.Component {
  render () {
    const {showDeleteDiscountModal, deletedDiscount} = this.props
    return (<Modal show={showDeleteDiscountModal} onHide={this._onHide} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        Delete Discount
      </Modal.Header>
      <Modal.Body>
        {deletedDiscount && <p>Are you sure want to delete <b>{deletedDiscount.name}</b> ? This action cannot be undone</p>}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={this._onHide} className='btn btn-default'>Cancel</button>
        <button onClick={this._onConfirm} className='btn btn-danger'>Delete</button>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(cancelDeleteDiscount())
  }

  _onConfirm = () => {
    let {deletedDiscount, dispatch, discounts} = this.props
    dispatch(deleteDiscount(deletedDiscount.id, discounts))
  }
}

function mapStateToProps (state) {
  const {deletedDiscount, showDeleteDiscountModal, discounts} = state.library.discount
  return {
    deletedDiscount,
    showDeleteDiscountModal,
    discounts
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteModal)



// WEBPACK FOOTER //
// ./app/pages/Library/Discount/ConfirmDeleteModal/ConfirmDeleteModal.js